<template>
  <div>
    <Form :model="formData" label-position="left" :label-width="0" inline>
      <!-- 客户组 -->
      <FormItem v-if="formData.hasOwnProperty('company_code')">
        <companyList
          ref="company"
          :company-code="formData.company_code"
          width="100"
          size="small"
          @updateCompanyCode="
            e => {
              formData.company_code = e;
            }
          "
        ></companyList>
      </FormItem>
      <!-- 姓名 -->
      <FormItem v-if="formData.hasOwnProperty('name')">
        <Input
          v-model="formData.name"
          size="small"
          :placeholder="$t('user.name')"
          :style="styles.name"
          clearable
        ></Input>
      </FormItem>
      <!-- 手机号 -->
      <FormItem v-if="formData.hasOwnProperty('phone') || formData.hasOwnProperty('login_phone')">
        <Input
          v-model="formData.phone"
          size="small"
          :placeholder="$t('user.phone')"
          :style="styles.phone"
          clearable
          v-if="formData.phone != undefined"
        ></Input>
        <Input
        v-else
          v-model="formData.login_phone"
          size="small"
          :placeholder="$t('user.phone')"
          :style="styles.phone"
          clearable
        ></Input>
      </FormItem>
      <!-- 邮箱 -->
      <FormItem v-if="formData.hasOwnProperty('email')|| formData.hasOwnProperty('login_email')">
        <Input
        v-if="formData.email != undefined"
          v-model="formData.email"
          size="small"
          :placeholder="$t('user.email')"
          :style="styles.email"
          clearable
        ></Input>
        <Input
        v-else
          v-model="formData.login_email"
          size="small"
          :placeholder="$t('user.email')"
          :style="styles.email"
          clearable
        ></Input>
      </FormItem>
      <!-- 公司 -->
      <FormItem v-if="formData.hasOwnProperty('company')">
        <dictionaryList
          :dictionary-code="formData.company"
          :dictionary-category="'COMPANY'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.company = e;
            }
          "
        ></dictionaryList>
      </FormItem>
      <!-- 区域 -->
      <FormItem v-if="formData.hasOwnProperty('location')">
        <dictionaryList
          :dictionary-code="formData.location"
          :dictionary-category="'LOCATION'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.location = e;
            }
          "
        ></dictionaryList>
      </FormItem>
      <!-- 城市 -->
      <FormItem v-if="formData.hasOwnProperty('city')">
        <dictionaryList
          :dictionary-code="formData.city"
          :dictionary-category="'CITY'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.city = e;
            }
          "
        ></dictionaryList>
      </FormItem>

      <template v-for="tag in tags">
        <FormItem v-if="formData.hasOwnProperty(tag)" :key="tag">
          <dictionaryList
            :isClear="isClear"
            :dictionary-category="tag.toLocaleUpperCase()"
            width=""
            :isCustomTagData="isCustomTagData"
            :customTagDataType="customTagDataType"
            @updateDictionaryCode="
              e => {
                formData[tag] = e;
              }
            "
          ></dictionaryList>
        </FormItem>
      </template>

      <!-- TAG1 -->
      <!-- <FormItem v-if="formData.hasOwnProperty('tag1')">
        <dictionaryList
          :isClear="isClear"
          :dictionary-category="'TAG1'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.tag1 = e;
            }
          "
        ></dictionaryList>
      </FormItem> -->
      <!-- TAG2 -->
      <!-- <FormItem v-if="formData.hasOwnProperty('tag2')">
        <dictionaryList
          :isClear="isClear"
          :dictionary-category="'TAG2'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.tag2 = e;
            }
          "
        ></dictionaryList>
      </FormItem> -->
      <!-- TAG3 -->
      <!-- <FormItem v-if="formData.hasOwnProperty('tag3')">
        <dictionaryList
          :isClear="isClear"
          :dictionary-category="'TAG3'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.tag3 = e;
            }
          "
        ></dictionaryList>
      </FormItem> -->
      <!-- TAG4 -->
      <!-- <FormItem v-if="formData.hasOwnProperty('tag4')">
        <dictionaryList
          :isClear="isClear"
          :dictionary-category="'TAG4'"
          :width="120"
          @updateDictionaryCode="
            e => {
              formData.tag4 = e;
            }
          "
        ></dictionaryList>
      </FormItem> -->
      <!-- TAG5 -->
      <!-- <FormItem v-if="formData.hasOwnProperty('tag5')">
        <dictionaryList
          :isClear="isClear"
          :dictionary-category="'TAG5'"
          :width="135"
          @updateDictionaryCode="
            e => {
              formData.tag5 = e;
            }
          "
        ></dictionaryList>
      </FormItem> -->

      <!-- 是否为内部人员 -->
      <FormItem v-if="formData.hasOwnProperty('is_internal')">
        <Select
          v-model="formData.is_internal"
          :placeholder="$t('user.is_internal')"
          clearable
          size="small"
          style="width:100px;"
        >
          <Option value="true">Y</Option>
          <Option value="false">N</Option>
        </Select>
      </FormItem>
      <FormItem
        v-if="
          formData.hasOwnProperty('is_online') ||
            formData.hasOwnProperty('is_onsite')
        "
      >
        <Checkbox
          v-if="formData.hasOwnProperty('is_online')"
          v-model="formData.is_online"
          >{{ "event_detail.online" | t }}</Checkbox
        >
        <Checkbox
          v-if="formData.hasOwnProperty('is_onsite')"
          v-model="formData.is_onsite"
          >{{ "event_detail.onsite" | t }}</Checkbox
        >
      </FormItem>
      <!-- 审批状态 -->
      <FormItem
        v-if="
          formData.hasOwnProperty('is_approved') ||
            formData.hasOwnProperty('is_finished')
        "
      >
        <Select
        @on-change="changeStatus"
          v-model="status"
          :placeholder="$t('event_detail.registration_status')"
          clearable
          size="small"
          style="width:100px;"
        >
          <Option v-for="(item, index) in approved_status" :key="item" :value="index">{{item}}</Option>
        </Select>
      </FormItem>
      <!-- <FormItem> -->
        <slot></slot>
      <!-- </FormItem> -->
      <FormItem>
        <Button type="primary" size="small" @click="searchHandler">{{
          $t("search")
        }}</Button>
        <Button type="success" size="small" @click="clearHandler">{{
          $t("clear")
        }}</Button>
        <Divider type="vertical" v-if="useCustom" />
        <Button type="primary" size="small"  v-if="formData.hasOwnProperty('customFunc')&&useCustom" @click="customHandler">{{
          formData.customFunc
          }}</Button>
        <Button type="error" size="small"  v-if="formData.hasOwnProperty('custom2Func')&&useCustom" @click="custom2Handler">{{
          formData.custom2Func
          }}</Button>
        <Divider type="vertical" v-if="useCustom" />
        <Button type="primary" size="small"  v-if="formData.hasOwnProperty('export_file')&&useCustom" @click="exportHandler">{{
          formData.export_file
          }}</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
/**
 * 功能:  根据要收集的表单数据来生成对应的表单
 * formData字段:
 *      phone: 手机号输入框
 *      email: 邮箱输入框
 *      company: 公司下拉框
 *      location: 区域下拉框
 *      city: 城市下拉框
 *      tag1: tag1下拉框
 *      tag2: tag2下拉框
 *      tag3: tag3下拉框
 *      tag4: tag4下拉框
 *      tag5: tag5下拉框
 *      is_internal: 内部人员下拉框
 *
 */
import company_list from "@/components/company_list";
import dictionary_list from "@/components/dictionary_list";
export default {
  name: "Search",
  components: {
    companyList: company_list,
    dictionaryList: dictionary_list
  },
  data() {
    return {
      isClear: false,
      tags: ["tag1", "tag2", "tag3", "tag4", "tag5"],
      approved_status: [
        this.$t("event_detail.confirmed_status.PENDING"),
        this.$t("event_detail.approve"),
        this.$t("event_detail.confirmed_status.REJECTED")
      ],
      status: null
    };
  },
  props: {
    // 表单数据
    formData: {
      type: Object,
      default: () => ({})
    },
    // 搜索函数
    search: {
      type: Function,
      default: () => {}
    },
    // 清空函数
    clear: {
      type: Function,
      default: () => {}
    },
    // 导出函数
    export_file:{
      type:Function,
      default:()=>{}
    },
    customFunc:{
      type:Function,
      default:()=>{}
    },
    custom2Func:{
      type:Function,
      default:()=>{}
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    isCustomTagData: {
      type: Boolean,
      default: false
    },
    customTagDataType: {
      type: String,
      default: ""
    },
    useCustom:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    // 审批表状态
    changeStatus(value){
      console.log(value);
      if(value===undefined){
        this.formData.is_approved = this.formData.is_finished = null
      }
      if(value === 0){
        this.formData.is_finished = false;
        this.formData.is_approved = null;
      }
      if(value === 1){
        this.formData.is_finished = null;
        this.formData.is_approved = true;
      }
      if(value === 2){
        this.formData.is_finished = null;
        this.formData.is_approved = false;
      }
    },
    searchHandler() {
      console.info("this.formData", this.formData);
      this.formData.page_index = 1;
      this.$emit("search");
    },
    clearHandler() {
      this.isClear = !this.isClear;
      this.status = null;
      // this.isClear = true;
      this.$emit("clear");
    },
    exportHandler(){
      this.$emit("export_file",this.formData);
    },
    customHandler(){
      this.$emit("customFunc",this.formData);
    },
    custom2Handler(){
      this.$emit("custom2Func",this.formData);
    }
  }
};
</script>

<style scoped>
.ivu-select-dropdown {
  max-width: 208px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue